import config from '../config'
import Helmet from 'react-helmet'
import React from 'react'

function helmet(title, description, url){
  const propTitle = title + ' - ' + config.app.title
  url = url || config.domain
  description = description || config.description
  return(
    <Helmet
      title={title}
      meta={[
        {property: 'og:url', content: url},
        {property: 'twitter:title', content: propTitle },
        {property: 'og:site_name', content: propTitle },
        {property: 'og:title', content: propTitle },
        {name: 'description', content: description},
        {property: 'twitter:description', content: description},
        {property: 'og:description', content: description },
      ]}
    />
  )
}
export default {
  helmet,
}